'use client';

import { useEffect, FC } from 'react';
import { clearUserAuthFormData } from 'src/stores/authStore';

/**
 * This component is intended to be placed in the layout of authentication route.
 * It monitors route changes and clears specified authentication form data cookies
 * when the user navigates *away* from any path within the defined authentication routes.
 */
export const ResetAuthFormManager: FC = () => {
  const handleRemoveAuthFormCookie = () => {
    clearUserAuthFormData();
  };
  useEffect(() => {
    window.addEventListener('beforeunload', handleRemoveAuthFormCookie);
    return () => {
      handleRemoveAuthFormCookie();
      window.removeEventListener('beforeunload', handleRemoveAuthFormCookie);
    };
  }, []);

  return null;
};
